<template>
  <div class="TextBox">
    <h2>{{ title }}</h2>
    <div><slot></slot></div>
  </div>
</template>

<script>
export default {
  name: "TextBox",
  props: {
    title: {
      type: String,
      require: true
    }
  },
  computed: {
  }
}
</script>

<style lang="scss" scoped>
.TextBox {
  margin: 30px 30px 0;
  padding: 30px 20px;
  border: 2px solid #F9B0BC;
  border-radius: 4px;
  box-shadow: inset 0 0 0 4px #fff, inset 0 0 0 5px #F9B0BC;
  h2 {
    font-size: 14px;
    color: #4B4344;
    font-weight: normal;
  }
  div {
    margin-top: 10px;
    font-size: 12px;
    color: #373737;
  }
}
</style>
